import gql from 'graphql-tag';

const key = `UpdatePprFeedback`;
const mutation = gql`
mutation ${key}($id:ID!, $feedback: CommentInput!) {
updatePeriodPlanResult(input:{
    id:$id,
    managerFeedback:$feedback
  }){
    id
    managerFeedback {
      commenter
      body
    }
    member {
      id
      firstName
      lastName
    }
  }
}
`;

export const UPDATE_PPR_FEEDBACK = { key, mutation };
